const LAYERS = [
  { label: 'New account ramp', desc: 'Gradual send limits', color: '#FFF5ED', border: '#FFD9B3', dark: false },
  { label: 'Auto-pause', desc: 'Bounce/complaint triggers', color: '#FFF0E0', border: '#FF9E4F', dark: false },
  { label: 'Smart signals', desc: 'Pattern detection', color: '#FFE8D0', border: '#FF6B00', dark: false },
  { label: 'Manual review', desc: 'Human in the loop', color: '#1a1216', border: '#1a1216', dark: true },
] as const

export function ShieldVisual() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {LAYERS.map((l, i) => (
        <div
          key={i}
          style={{
            padding: '14px 18px', borderRadius: 12,
            background: l.color, border: `1px solid ${l.border}`,
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          }}
        >
          <span style={{ fontWeight: 700, fontSize: 14, color: l.dark ? '#fff' : '#1a1216' }}>
            {l.label}
          </span>
          <span style={{ fontSize: 12, color: l.dark ? '#a09898' : '#6d6462' }}>
            {l.desc}
          </span>
        </div>
      ))}
      <div
        style={{
          textAlign: 'center', fontSize: 12, color: '#777',
          fontFamily: "var(--oe-font-mono)", marginTop: 4,
        }}
      >
        4 layers between a bad sender and your reputation
      </div>
    </div>
  )
}
